import classnames from "classnames";
import React from "react";
import { BannerSlider } from "src/components";
import styled from "styled-components";

import { Slice } from "../components";
import { ISliceSliderImages } from "../types";

const StyledBannerSlider = styled(BannerSlider)`
  &&& {
    padding: 0;
  }

  margin: 30px 0;
`;

export const SliderImages = ({
  slice_type,
  primary,
  items,
}: ISliceSliderImages): JSX.Element | null => {
  const { class_name: className } = primary;

  // TODO:review isEmpty
  const isEmpty = false;

  if (isEmpty) {
    return null;
  }

  const sliderItems = items.map((item) => ({
    src: item.slider_image,
    url: item.slider_image_url,
    background_size: item.slider_image_background_size,
  }));

  return (
    <Slice
      className={classnames("slice-slider-images", className)}
      padding="0"
      noGutter
    >
      <StyledBannerSlider
        data={{
          primary,
          items: sliderItems,
        }}
      />
    </Slice>
  );
};
